type PersonName = {
  fullName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
} | null | undefined;

const cleanNamePart = (value?: string | null) =>
  typeof value === "string" ? value.trim() : "";

export const formatPersonName = (
  person?: PersonName,
  fallback = "-",
) => {
  const fullName = cleanNamePart(person?.fullName);
  const name = [person?.firstName, person?.lastName]
    .map(cleanNamePart)
    .filter(Boolean)
    .join(" ");

  return fullName || name || fallback;
};
